// pages/protected-page/service/pages/PageDetail.jsx
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { motion } from "framer-motion";
import Loading from "../../components/Loading";
import BackNavigationBar from "../../components/BackNavigationBar";

import {
  dang_ky_nhan_hieu,
  dang_ky_kieu_dang_cong_nghiep,
  dang_ky_sang_che_giai_phap_huu_ich,
  dang_ky_gia_han,
  dang_ky_sua_doi_don_van_bang,
  chuyen_giao_chuyen_nhuong_don_van_bang,
  tra_cuu_thong_tin,
  dang_ky_ban_quyen,
  dich_vu_khac,
} from "../data/form_data";

import { AuthContext } from "../../../../contexts/AuthContext";
import { serviceService } from "../../../../services/api/serviceService";
import DynamicForm from "../forms/DynamicForm";

const mapSlugToForm = (slug) => {
  switch (slug) {
    case "dang-ky-nhan-hieu":
      return dang_ky_nhan_hieu;
    case "dang-ky-kieu-dang-cong-nghiep":
      return dang_ky_kieu_dang_cong_nghiep;
    case "dang-ky-sang-che-giai-phap-huu-ich":
      return dang_ky_sang_che_giai_phap_huu_ich;
    case "dang-ky-gia-han":
      return dang_ky_gia_han;
    case "dang-ky-sua-doi-don-van-bang":
      return dang_ky_sua_doi_don_van_bang;
    case "chuyen-giao-chuyen-nhuong-don-van-bang":
      return chuyen_giao_chuyen_nhuong_don_van_bang;
    case "tra-cuu-thong-tin":
      return tra_cuu_thong_tin;
    case "dang-ky-ban-quyen":
      return dang_ky_ban_quyen;
    case "dich-vu-khac":
      return dich_vu_khac;
    default:
      return null;
  }
};

const PageDetail = ({ isMobile }) => {
  const navigate = useNavigate();
  const { slug, id } = useParams();
  const { token_client } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [category, setCategory] = useState("");
  const [serviceName, setServiceName] = useState("");
  const [formData, setFormData] = useState([]);

  // Lấy form theo slug (memo để tránh tính lại)
  const formBySlug = useMemo(() => mapSlugToForm(slug), [slug]);

  const fetchServiceMeta = useCallback(async () => {
    try {
      setLoading(true);
      const response = await serviceService.get_service_by_id(id, token_client);
      setCategory(response?.category?.categoryName || "");
      setServiceName(response?.serviceName || "");
    } catch (error) {
      toast.dismiss();
      toast.error("Lỗi khi lấy dịch vụ từ server");
    } finally {
      setLoading(false);
    }
  }, [id, token_client]);

  useEffect(() => {
    if (!formBySlug) {
      toast.dismiss();
      toast.error("Không tồn tại form có tên như trên!!");
      navigate("/");
      return;
    }
    setFormData(formBySlug);
    fetchServiceMeta();
  }, [formBySlug, fetchServiceMeta, navigate]);

  if (loading) {
    return (
      <div
        className={`flex ${
          isMobile ? "h-screen w-screen" : "h-full"
        } items-center justify-center`}
      >
        <Loading />
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: 8, scale: 0.99 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
      className="h-full w-full pb-20"
    >
      <BackNavigationBar
        ariaLabel="Quay lại"
        className="backdrop-blur"
        onBack={() => navigate(-1)}
        subtitle={category}
        title={serviceName || formData?.name}
      />

      <DynamicForm
        formData={formData}
        id={slug}
        serviceId={id}
        token_client={token_client}
        category={category}
        isMobile={isMobile}
        serviceName={serviceName}
      />
    </motion.div>
  );
};

export default PageDetail;
